export const VARIABLE_PREFIX = '@';
